import { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { getCookieValueByKey, setCookieByKey } from '@utils/cookieHelper';
import { activityEventUpdate, setAdditionalProperties } from 'fmc-digital-common';
import { config } from '../config';

/**
 * Custom hook to extract the user details
 * @returns Logged in user details.
 */
export const useUserDetails = () => {
    const { authState, oktaAuth } = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const activityUpdateUrl = config.env('activityUpdateUrl');

    useEffect(() => {
        if (authState) {
            if (!authState.isAuthenticated) {
                setUserInfo(null);
            } else if (!userInfo) {
                oktaAuth.getUser().then(info => {
                    setUserInfo(info);
                });
            }

            if (authState.isAuthenticated) {
                const token = oktaAuth.getAccessToken();
                if (token !== undefined) {
                    setAdditionalProperties('authToken', token);
                    const response = activityEventUpdate([{ activityType: 'ACPLogin', activityResult: 'SUCCESS' }], activityUpdateUrl);
                }
            }
        } else {
            oktaAuth.signInWithRedirect({ originalUri: '/' });
        }
    }, [authState, oktaAuth]);

    return [userInfo] as const;
};
